import React from 'react';

export interface ErrorListProps {
    errors: string[];
    children?: any;
}

const ErrorList: React.FC<ErrorListProps> = props => {
    if (props.errors == null || props.errors.length === 0) return null;
    
    return <div className="error-list">
        {props.children}
        {props.errors.map((error, i) => 
            <div key={i} className="error">{error}</div>
        )}
    </div>
}

export default ErrorList;